export default {
	COLOR_POINT: "rgb(243,114,114)",
	COLOR_POINT_FILL: "rgb(255,255,255)",
	COLOR_LANDSCAPE: "#FFAD00",
	COLOR_WATER: "#0000FF",
	COLOR_BORDERS: "rgb(195,230,255)",
	COLOR_LINE: "rgb(255,255,255)",
	COLOR_SELECTED_POINT: "rgb(0,184,83)",

	COLOR_BLUE: "rgb(0,0,255)",
	COLOR_PINK: "rgb(255,0,0)",
};
